import { HttpParams } from '@angular/common/http';
import { MainTableFilterModel, PrintReportFilterModel } from '../models/main-table-filter.model';

/**
 * Creates HttpParams from MainTableFilterModel with standard filtering parameters
 * @param filter - The filter model containing pagination and search parameters
 * @param initialParams - Optional initial HttpParams to append to (useful for additional parameters)
 * @param columnMap - Optional mapping for orderBy field names (e.g., {'type': 'CertificateType'})
 * @returns HttpParams object with standard filtering parameters applied
 */
export function createFilterParams(
  filter?: MainTableFilterModel | PrintReportFilterModel,
  initialParams?: HttpParams,
  columnMap?: Record<string, string>
): HttpParams {
  let params = initialParams || new HttpParams();

  if (filter) {
    if (filter instanceof MainTableFilterModel) {
      params = params.set('Page', `${filter.pageIndex}`);
      params = params.set('PageSize', `${filter.pageSize}`);
    }

    if (filter.searchTerm) {
      params = params.set('GlobalSearch', filter.searchTerm);
    }

    if (filter.orderBy && filter.ascDesc) {
      const orderByField = columnMap?.[filter.orderBy] || filter.orderBy;
      params = params.set(`OrderBy[${orderByField}]`, filter.ascDesc);
    }
  }

  return params;
}
